import { popupManager } from 'edicom';

export default function ecPopupService() {
  return popupManager.create;
}
